<app-dialog [dialogWithInput]="dialog">
    <div class="text-center">
        <img style="max-width: 100%" [src]="dialog.input.image" />
    </div>
</app-dialog>
